import AdminFRDocumentsDispatcher from './admin_fr_documents_dispatcher';
import CustomerDispatcher from './customer_dispatcher';
import CustomizeDispatcher from './customize_dispatcher';
import DocumentsDispatcher from './documents_dispatcher';
import ElementsDispatcher from './elements_dispatcher';
import FinancingMethodsDispatcher from './financing_methods_dispatcher';
import FinancingProductsDispatcher from './financing_products_dispatcher';
import FinancingRequestDispatcher from './financing_request_dispatcher';
import FunctionalityAclsDispatcher from './functionality_acls_dispatcher';
import HomeownerPortalDispatcher from './homeowner_portal_dispatcher';
import HomeownerEligibilityDispatcher from './homeowner_eligibility_dispatcher';
import MessageDispatcher from './message_dispatcher';
import PageDispatcher from './page_dispatcher';
import PollingDispatcher from './polling_dispatcher';
import ProposalDispatcher from './proposal_dispatcher';
import RequestDispatcher from './request_dispatcher';
import UsersDispatcher from './users_dispatcher';
import UserSettingValuesDispatcher from './user_setting_values_dispatcher';
import AdminFinancingRequestsDispatcher from './admin/admin_financing_requests_dispatcher';
import DecisioningDispatcher from './decisioning_dispatcher';
import DisbursementDispatcher from './disbursement_dispatcher';
import ModalDispatcher from './modal_dispatcher';
import WelcomeCallDispatcher from './welcome_call_dispatcher';
import CustomerHistoryDispatcher from './customer_history_dispatcher';
import AuthenticationDispatcher from './authentication_dispatcher';
import PasswordResetDispatcher from './password_reset_dispatcher';
import { isEqual } from '../helpers/generic_utils';

const DispatcherApp = {
  dispatch(action) {
    // DebugHelper.trackAction(action);
    const { type, data } = action;
    const dispatchers = [
      CustomerDispatcher,
      CustomizeDispatcher,
      AdminFRDocumentsDispatcher,
      DocumentsDispatcher,
      ElementsDispatcher,
      FinancingMethodsDispatcher,
      FinancingProductsDispatcher,
      FinancingRequestDispatcher,
      FunctionalityAclsDispatcher,
      HomeownerPortalDispatcher,
      MessageDispatcher,
      ModalDispatcher,
      PageDispatcher,
      PollingDispatcher,
      ProposalDispatcher,
      RequestDispatcher,
      UsersDispatcher,
      UserSettingValuesDispatcher,
      HomeownerEligibilityDispatcher,
      AdminFinancingRequestsDispatcher,
      DecisioningDispatcher,
      DisbursementDispatcher,
      WelcomeCallDispatcher,
      CustomerHistoryDispatcher,
      AuthenticationDispatcher,
      PasswordResetDispatcher,
    ];

    if (type === 'noop') {
      return null;
    }

    const dispatcher = dispatchers.find((dispatcherPotential) => dispatcherPotential.hasOwnProperty(type));

    if (dispatcher) {
      return dispatcher[type].apply(this, [data]);
    }
    /* eslint-disable no-console */
    return console.error(`No handler for '${type}'`);
    /* eslint-enable no-console */
  },

  setStoreVal(key, val) {
    /* eslint-disable no-unused-expressions */
    this.updateStore?.((store) => {
      return {
        ...store,
        [key]: val,
      };
    });
    /* eslint-enable no-unused-expressions */
  },

  setStoreValWithCheck(key, val) {
    if (!isEqual(this.getStoreVal(key), val)) {
      this.updateStore?.((store) => ({ ...store, [key]: val }));
    }
  },

  getStoreVal(key) {
    const store = this.getStore();
    return store[key];
  },

  mergeStoreVal(key, val) {
    this.updateStore((store) => {
      return {
        ...store,
        [key]: { ...store[key], ...val },
      };
    });
  },

  pushStoreVal(key, val) {
    this.updateStore((store) => {
      return {
        ...store,
        [key]: [...store[key], val],
      };
    });
  },

  concatStoreVal(key, val) {
    this.updateStore((store) => {
      if (Array.isArray(store[key]) && Array.isArray(val)) {
        return {
          ...store,
          [key]: store[key].concat(val),
        };
      }
      return store;
    });
  },

  addToLock(key, num) {
    const currentLocks = this.getStoreVal('locks');
    const currentLockCount = currentLocks[key] || 0;
    let newLockCount = Math.max(currentLockCount + num, 0);
    this.mergeStoreVal('locks', { [key]: newLockCount });
    return newLockCount;
  },

  incrementLock(key) {
    return this.addToLock(key, 1);
  },

  decrementLock(key) {
    return this.addToLock(key, -1);
  },

  acquireLock(key) {
    const currentLocks = this.getStoreVal('locks');
    if (currentLocks && !currentLocks[key]) {
      this.incrementLock(key);
      return true;
    }
    return false;
  },

  releaseLock(key) {
    this.decrementLock(key);
  },
};

export default DispatcherApp;
